import React from 'react';
import { StockDataPoint } from '../types/StockData';

type TabType = 'signals' | 'flow' | 'volatility' | 'gamma' | 'flowPerStrike';

interface TabNavigationProps {
  activeTab: TabType;
  onTabChange: (tab: TabType) => void;
  selectedDataPoint: StockDataPoint | null;
}

const TabNavigation: React.FC<TabNavigationProps> = ({
  activeTab,
  onTabChange,
  selectedDataPoint
}) => {
  const tabs = [
    {
      id: 'signals' as TabType,
      label: 'Signals',
      count: selectedDataPoint?.signals?.length || 0
    },
    {
      id: 'flow' as TabType,
      label: 'Flow Alerts',
      count: selectedDataPoint?.flowAlerts?.length || 0
    },
    {
      id: 'volatility' as TabType,
      label: 'Volatility',
      count: null
    },
    {
      id: 'gamma' as TabType,
      label: 'Gamma Exposure',
      count: null
    },
    {
      id: 'flowPerStrike' as TabType,
      label: 'Flow Per Strike',
      count: null
    }
  ];

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 mb-6">
      <div className="flex border-b border-gray-200">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={`px-6 py-3 text-sm font-medium border-b-2 transition-all duration-200 first:rounded-tl-lg last:rounded-tr-lg ${
              activeTab === tab.id
                ? 'border-blue-500 text-blue-600 bg-blue-50'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:bg-gray-50'
            }`}
          >
            {tab.label} {tab.count !== null && `(${tab.count})`}
          </button>
        ))}
      </div>
    </div>
  );
};

export default TabNavigation;
